const RECEIVE_AD_AUTOMATION_STRATEGIES = 'src/adCampaignTypes/RECEIVE_AD_AUTOMATION_STRATEGIES' as const;
const CLEAR_AD_AUTOMATION_STRATEGIES = 'src/adCampaignTypes/CLEAR_AD_AUTOMATION_STRATEGIES' as const;

export default {
  CLEAR_AD_AUTOMATION_STRATEGIES,
  RECEIVE_AD_AUTOMATION_STRATEGIES
};
